import React from 'react';
import { Link } from 'react-router-dom';

import { Breadcrumbs } from '@prisjakt/ui/breadcrumbs';
import { useAppContext } from 'src/components/app-context';

import {
  trackInternalNavigationClick,
  InternalNavigationScope,
} from 'src/globals/tracking/tracking';

import { BreadCrumbWrapper } from './styles';
import { useSelector } from 'react-redux';
import type { ArticleQuery, CampaignPageQuery } from 'src/types';
import type { AppState } from 'src/reducers';

type Props = {
  article?: ArticleQuery['article'];
  campaign?: CampaignPageQuery['campaign'];
};

export const CampaignBreadcrumb = (props: Props) => {
  const { t } = useAppContext();
  const base = useSelector((state: AppState) => {
    // @ts-expect-error typing to fix the error will be fixed soon
    return state.areas.campaign.base;
  });

  const getBreadcrumbPath = () => {
    const path = [
      {
        id: 'campaigns',
        name: t('campaigns', 'themes.breadcrumb'),
        pathName: base,
      },
    ];
    if (props.campaign) {
      path.push({
        id: `${props.campaign.id}`,
        name: props.campaign.name || '',
        pathName: `${base}/${props.campaign.slug}`,
      });
      if (props.article) {
        path.push({
          id: `${props.article.id}`,
          name: props.article.title,
          pathName: props.article.pathName,
        });
      }
    }
    return path;
  };

  const paths = getBreadcrumbPath();

  return (
    <BreadCrumbWrapper>
      <Breadcrumbs
        containerProps={{
          onClick: (nextPage: string) => {
            trackInternalNavigationClick({
              scope: InternalNavigationScope.BREADCRUMB,
              nextPage,
            });
          },
        }}
      >
        <Link to="/">{t('common', 'breadcrumb.home')}</Link>
        {paths.map((crumb, index) => {
          return paths.length - 1 === index ? (
            <span key={crumb.id}>{crumb.name}</span>
          ) : (
            <Link key={crumb.id} to={crumb.id}>
              {crumb.name}
            </Link>
          );
        })}
      </Breadcrumbs>
    </BreadCrumbWrapper>
  );
};

export default CampaignBreadcrumb;
